import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export type AddContactSearch = {
  // An existing contact that gets a new position, from its contact page.
  contactId?: number;
  // The employer of the new position, from the Contacts section of a client
  // page.
  clientId?: number;
};

function positiveId(value: unknown): number | undefined {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : undefined;
}

export const Route = createFileRoute('/_app/clients/representatives/add')({
  validateSearch: (search): AddContactSearch => {
    const contactId = positiveId(search.contactId);
    const clientId = positiveId(search.clientId);
    return {
      ...(contactId !== undefined ? { contactId } : {}),
      ...(clientId !== undefined ? { clientId } : {}),
    };
  },
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle(
          'clients.add_contact.page_title',
          'Add Client contact',
        ),
      },
    ],
  }),
});
